import { SignUp } from "@clerk/react";
import { AuthLoading, AuthShell } from "./AuthShell";
import { authUrl, defaultAuthDestination } from "./destination";
import { clerkAppearance } from "./clerkAppearance";

export function SignupPage({ destination }: { destination: string }) {
  return <AuthShell><SignUp
    path="/signup" routing="path" signInUrl={authUrl("login", destination)}
    fallbackRedirectUrl={defaultAuthDestination} signInFallbackRedirectUrl={defaultAuthDestination}
    forceRedirectUrl={authUrl("signup", destination)} signInForceRedirectUrl={authUrl("login", destination)}
    appearance={clerkAppearance} fallback={<AuthLoading title="Create your SignalBill account" />}
  /></AuthShell>;
}
